/**
 * Every tunable budget in one place. Values are provisional until profiled
 * against a synthetic 1000-test pack (scripts/make-fixtures.mjs) — measured,
 * not sacred.
 */
var MiB = 1024 * 1024;

/** Ceiling for the whole-body cache when a server ignores Range requests. */
export var MAX_WHOLE_BODY_BYTES = 256 * MiB;

/** Refuse to read any single entry larger than this (checked against the
 * central directory BEFORE fetching a byte). */
export var MAX_ENTRY_BYTES = 128 * MiB;

/** Byte budget for decompressed artifact bytes (screenshots, logs). */
export var ARTIFACT_CACHE_BYTES = 64 * MiB;

/** Budgets for object URLs handed to <img>/<video>. */
export var OBJECT_URL_CACHE_BYTES = 64 * MiB;
export var OBJECT_URL_CACHE_COUNT = 100;

/** Hydration concurrency: HTTP/1.1 allows 6 connections per origin (the
 * kane-cli localhost server is exactly that); Blob reads are memcpy-cheap. */
export var HYDRATE_CONCURRENCY_HTTP = 6;
export var HYDRATE_CONCURRENCY_BLOB = 12;

/** Yield to the event loop when parse work exceeds this budget in a frame. */
export var YIELD_BUDGET_MS = 8;

/** Yield while parsing huge central directories, every N entries. */
export var CD_PARSE_YIELD_EVERY = 2500;

/** Loader cap on failure-index rows read from failure.yaml (each row may
 * cost one ~1 KB ranged read for its per-step detail file). Feeds BOTH the
 * report widget and the Issues tab — the Issues tab wants them all; 100
 * failures in one pack is already beyond any sane run. */
export var MAX_ATTENTION_ITEMS = 100;

/** The report "Need your attention" widget renders at most this many rows
 * (preserves its pre-Issues-tab height now the loader cap is higher). */
export var ATTENTION_DISPLAY_ITEMS = 20;

/** Detail view: refuse to load an NDJSON log entry bigger than this (checked
 * against the central directory before fetching a byte — the drawer shows an
 * honest "too large" state instead). */
export var MAX_LOG_TEXT_BYTES = 32 * MiB;

/** Detail view: cap for auteur/execution.json (sample packs: ~93 KB). */
export var MAX_EXECUTION_JSON_BYTES = 16 * MiB;

/** Screenshot prefetch window around the selected step. */
export var SCREENSHOT_PREFETCH_AHEAD = 2;
export var SCREENSHOT_PREFETCH_BEHIND = 1;

/** step.json reads per test are pooled — a 500-step test must not fire
 * hundreds of concurrent ranged reads. */
export var STEPJSON_READ_CONCURRENCY = 6;